import React from 'react';
import { Typography } from 'antd';
import {
  OfferedItemDetails,
  ProjectHomeIdentifiersProps,
} from './OfferedItemDetails';
import { Subcategory2Group } from './Subcategory2Group';
import { OfferedItemLookup } from './useOfferedItemsDataSource';

const { Title } = Typography;

type Sub = {
  name: string;
  subcategories2: string[];
};

type Props = ProjectHomeIdentifiersProps & {
  category: string;
  sub: Sub;
  items: OfferedItemLookup[];
  stepId: string;
};

export const SubcategoryGroup: React.FC<Props> = (props) => {
  const { category, sub, items, ...rest } = props;

  return (
    <div key={sub.name} className="mb-2">
      <div id={`subcategory-${sub.name}`}>
        <Title level={4}>{sub.name}</Title>
      </div>
      {items
        .filter(
          (i) =>
            i.category === category &&
            i.subcategory === sub.name &&
            !i.subcategory2,
        )
        .map((item) => (
          <OfferedItemDetails
            key={item.id}
            item={item}
            {...rest}
            className="mb-2"
          />
        ))}
      {sub.subcategories2.length > 0 &&
        sub.subcategories2.map((sub2) => (
          <Subcategory2Group
            key={sub2}
            category={category}
            sub={sub.name}
            sub2={sub2}
            items={items}
            {...rest}
          />
        ))}
    </div>
  );
};
